import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-template-editor-dialog',
  templateUrl: './template-editor-dialog.component.html'
})
export class TemplateEditorDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
